import {
    faFacebookSquare,
    faInstagramSquare,
    faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
    faPlus,
    faEdit,
    faAngleRight,
    faHome,
    faMoneyCheck,
    faGem,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import { AbrirAtendimento } from "../../../../Components/CardsPages/Atendimento/AbrirAtendimento";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import WhatsappAtivo, {
    InforWhatsappSend,
} from "../../../../Components/Utils/WhatsappAtivo";
import { useUserInfor } from "../../../../Context/User";
import { ClienteInterface } from "../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import { formatedTelefone } from "../../../../Tools/FormatTools";
import { FormatterCPF } from "../../../../Validations/InputMasks";

const ModulosID = {
    Cobranca: {
        id: ACESSOS.COBRANCA.ID_MODULO,
        ds: "Cobrança",
    },
    Atendimento: {
        id: ACESSOS.ATENDIMENTO.ID_MODULO,
        ds: "Atendimento ao Cliente",
    },
} as { [index: string]: { id: number; ds: string } };

interface IClientesRowProps {
    row: ClienteInterface;
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
}

export default function ClientesRow(props: IClientesRowProps) {
    const location = useLocation();
    const modulo_url = location.pathname.split("/")[1];

    const { UserInfor } = useUserInfor();
    const cliente = props.row;

    return (
        <div
            key={cliente.ID_CONTA}
            className="card card-custom my-2 cliente-card"
        >
            <div className="card-body pt-3 pb-3">
                <div className="d-flex ">
                    <div className="flex-grow-1">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="mr-3">
                                <Link
                                    to={`/${
                                        location.pathname.split("/")[1]
                                    }/Cliente/${cliente.ID_CONTA}`}
                                    className="d-flex align-items-center text-dark text-hover-primary font-size-h2 font-weight-bold mr-3"
                                >
                                    {cliente.DS_CONTA}
                                    <i className="flaticon2-correct text-success icon-md ml-2"></i>
                                </Link>
                                <div className="d-flex flex-wrap my-2">
                                    {cliente.DS_EMAIL && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    id="email-tooltip"
                                                    className={`cliente-tooltip ${
                                                        cliente.DS_EMAIL
                                                            .length <= 1 &&
                                                        "tooltip-disabled"
                                                    } `}
                                                >
                                                    <div className="d-flex flex-column">
                                                        {cliente.DS_EMAIL.map(
                                                            (email) => {
                                                                return (
                                                                    <span
                                                                        key={
                                                                            email
                                                                        }
                                                                    >
                                                                        {email}
                                                                    </span>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </Tooltip>
                                            }
                                            trigger={["click"]}
                                        >
                                            <a
                                                href="#/"
                                                className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                                            >
                                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            strokeWidth="1"
                                                            fill="none"
                                                            fillRule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            ></rect>
                                                            <path
                                                                d="M21,12.0829584 C20.6747915,12.0283988 20.3407122,12 20,12 C16.6862915,12 14,14.6862915 14,18 C14,18.3407122 14.0283988,18.6747915 14.0829584,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,12.0829584 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                                                                fill="#000000"
                                                            ></path>
                                                            <circle
                                                                fill="#000000"
                                                                opacity="0.3"
                                                                cx="19.5"
                                                                cy="17.5"
                                                                r="2.5"
                                                            ></circle>
                                                        </g>
                                                    </svg>
                                                </span>
                                                {cliente.DS_EMAIL[0]}
                                                {cliente.DS_EMAIL.length >
                                                    1 && (
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        className="ml-2 text-success"
                                                    />
                                                )}
                                            </a>
                                        </OverlayTrigger>
                                    )}
                                    {cliente.NR_CPF && (
                                        <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                <i className="far fa-address-card"></i>
                                            </span>
                                            {FormatterCPF(cliente.NR_CPF)}
                                        </span>
                                    )}
                                    {cliente.NR_TELEFONE && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    id="telefone-tooltip"
                                                    className={`cliente-tooltip ${
                                                        cliente.NR_TELEFONE
                                                            .length <= 1 &&
                                                        "tooltip-disabled"
                                                    } `}
                                                >
                                                    <div className="d-flex flex-column">
                                                        {cliente.NR_TELEFONE.map(
                                                            (tel, index) => {
                                                                return (
                                                                    <span
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        {formatedTelefone(
                                                                            tel
                                                                        )}
                                                                    </span>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </Tooltip>
                                            }
                                            trigger={["click"]}
                                        >
                                            <span
                                                role="button"
                                                className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                                            >
                                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            strokeWidth="1"
                                                            fill="none"
                                                            fillRule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            />
                                                            <path
                                                                d="M7.13888889,4 L7.13888889,19 L16.8611111,19 L16.8611111,4 L7.13888889,4 Z M7.83333333,1 L16.1666667,1 C17.5729473,1 18.25,1.98121694 18.25,3.5 L18.25,20.5 C18.25,22.0187831 17.5729473,23 16.1666667,23 L7.83333333,23 C6.42705272,23 5.75,22.0187831 5.75,20.5 L5.75,3.5 C5.75,1.98121694 6.42705272,1 7.83333333,1 Z"
                                                                fill="#000000"
                                                                fillRule="nonzero"
                                                            />
                                                            <polygon
                                                                fill="#000000"
                                                                opacity="0.3"
                                                                points="7 4 7 19 17 19 17 4"
                                                            />
                                                            <circle
                                                                fill="#000000"
                                                                cx="12"
                                                                cy="21"
                                                                r="1"
                                                            />
                                                        </g>
                                                    </svg>
                                                </span>
                                                {/* {formatedTelefone( */}
                                                {cliente.NR_TELEFONE[0]}
                                                {/* )} */}
                                                {cliente.NR_TELEFONE.length >
                                                    1 && (
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        className="ml-2"
                                                    />
                                                )}
                                            </span>
                                        </OverlayTrigger>
                                    )}

                                    {UserInfor.FUNCOES.some(
                                        (f) =>
                                            f.NM_FUNCAO ===
                                            "WHATS_MENSAGEM_ATIVA"
                                    ) && (
                                        <span className="svg-icon svg-icon-md svg-icon-gray-500  mr-1">
                                            <WhatsappAtivo
                                                onClick={() => {
                                                    props.setShow(true);
                                                    props.setModal({
                                                        headerComponent:
                                                            "Enviar mensagem!",
                                                        IconHeader: faWhatsapp,
                                                        size: "lg",
                                                        Component: () => (
                                                            <InforWhatsappSend
                                                                lstContatos={
                                                                    cliente.NR_TELEFONE
                                                                }
                                                                setModal={
                                                                    props.setShow
                                                                }
                                                            />
                                                        ),
                                                        noFooter: true,
                                                    });
                                                }}
                                            />
                                        </span>
                                    )}
                                    {cliente.DS_CARGO && (
                                        <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24px"
                                                    height="24px"
                                                    viewBox="0 0 24 24"
                                                    version="1.1"
                                                >
                                                    <g
                                                        stroke="none"
                                                        strokeWidth="1"
                                                        fill="none"
                                                        fillRule="evenodd"
                                                    >
                                                        <mask fill="white">
                                                            <use href="#path-1"></use>
                                                        </mask>
                                                        <g></g>
                                                        <path
                                                            d="M7,10 L7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 L17,10 L18,10 C19.1045695,10 20,10.8954305 20,12 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,12 C4,10.8954305 4.8954305,10 6,10 L7,10 Z M12,5 C10.3431458,5 9,6.34314575 9,8 L9,10 L15,10 L15,8 C15,6.34314575 13.6568542,5 12,5 Z"
                                                            fill="#000000"
                                                        ></path>
                                                    </g>
                                                </svg>
                                            </span>
                                            {cliente.DS_CARGO}
                                        </span>
                                    )}

                                    {cliente.ENDERECO.DS_CIDADE &&
                                        cliente.ENDERECO.DS_CIDADE.length > 0 &&
                                        cliente.ENDERECO.DS_UF_ESTADO &&
                                        cliente.ENDERECO.DS_UF_ESTADO.length >
                                            0 && (
                                            <span className="text-muted text-hover-primary font-weight-bold  mr-lg-8 mr-5 mb-lg-0 mb-2">
                                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            strokeWidth="1"
                                                            fill="none"
                                                            fillRule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            ></rect>
                                                            <path
                                                                d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                                                                fill="#000000"
                                                            ></path>
                                                        </g>
                                                    </svg>
                                                </span>{" "}
                                                {cliente.ENDERECO &&
                                                    cliente.ENDERECO
                                                        .DS_CIDADE}{" "}
                                                -{" "}
                                                {cliente.ENDERECO &&
                                                    cliente.ENDERECO
                                                        .DS_UF_ESTADO}
                                            </span>
                                        )}
                                    <div>
                                        {cliente.REDES_SOCIAIS
                                            .DS_URL_FACEBOOK && (
                                            <a
                                                href={
                                                    cliente.REDES_SOCIAIS
                                                        .DS_URL_FACEBOOK
                                                }
                                                rel="noreferrer"
                                                className="text-muted text-hover-primary font-weight-bold"
                                            >
                                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                    <FontAwesomeIcon
                                                        icon={faFacebookSquare}
                                                        style={{
                                                            stroke: "none",
                                                            strokeWidth: "1",
                                                            width: "24px",
                                                            height: "24px",
                                                            fill: "none",
                                                            fillRule: "evenodd",
                                                        }}
                                                    />
                                                </span>
                                            </a>
                                        )}

                                        {cliente.REDES_SOCIAIS
                                            .DS_URL_INSTAGRAM && (
                                            <a
                                                href={
                                                    cliente.REDES_SOCIAIS
                                                        .DS_URL_INSTAGRAM
                                                }
                                                rel="noreferrer"
                                                className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                                            >
                                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1 colorInstagram">
                                                    <FontAwesomeIcon
                                                        icon={faInstagramSquare}
                                                        style={{
                                                            stroke: "none",
                                                            strokeWidth: "1",
                                                            width: "24px",
                                                            height: "24px",
                                                            fill: "none",
                                                            fillRule: "evenodd",
                                                        }}
                                                    />
                                                </span>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="my-lg-0 my-1">
                                <Link
                                    to={`/${
                                        location.pathname.split("/")[1]
                                    }/Cliente/${cliente.ID_CONTA}`}
                                    className="btn btn-sm btn-light-success mr-2 "
                                >
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        className="mr-2"
                                    />
                                    Visualizar
                                </Link>

                                <div className="btn-group">
                                    {modulo_url === "Cobranca" ||
                                    modulo_url === "Atendimento" ? (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-light-primary"
                                            onClick={() => {
                                                props.setShow(true);
                                                props.setModal({
                                                    headerComponent:
                                                        "Abrir Atendimento",
                                                    IconHeader: faAngleRight,
                                                    Component: () => (
                                                        <AbrirAtendimento
                                                            ID_MODULO={
                                                                ModulosID[
                                                                    modulo_url
                                                                ].id
                                                            }
                                                            setShow={
                                                                props.setShow
                                                            }
                                                            defaultDesc={`Atendimento aberto pela tela de Gestão de Clientes de ${ModulosID[modulo_url].ds}`}
                                                            cliente={{
                                                                ...props.row,
                                                                PRODUTOS:
                                                                    props.row.PRODUTOS.flatMap(
                                                                        (p) =>
                                                                            p.UNIDADES.map(
                                                                                (
                                                                                    u
                                                                                ) => ({
                                                                                    DS_EMPREENDIMENTO:
                                                                                        p.DS_PRODUTO,
                                                                                    ID_EMPREENDIMENTO:
                                                                                        p.ID_PRODUTO,
                                                                                    UNIDADE:
                                                                                        u,
                                                                                })
                                                                            )
                                                                    ),
                                                                CONTATOS:
                                                                    props.row.CONTATOS.map(
                                                                        (
                                                                            c
                                                                        ) => ({
                                                                            DS_NOME_CONTATO:
                                                                                c.DS_NOME,
                                                                            ID_CONTATO:
                                                                                c.ID_CONTATO,
                                                                        })
                                                                    ),
                                                            }}
                                                        />
                                                    ),
                                                    size: "xl",
                                                });
                                            }}
                                        >
                                            Abrir Atendimento
                                        </button>
                                    ) : (
                                        <>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light-primary dropdown-toggle"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                            >
                                                Abrir Atendimento
                                            </button>
                                            <div className="dropdown-menu">
                                                {UserInfor.MODULOS.filter(
                                                    (mod) =>
                                                        mod.ID_MODULO !==
                                                        ACESSOS.HELPDESK
                                                            .ID_MODULO &&
                                                        mod.ID_MODULO !==
                                                        ACESSOS.AUTOMACAO.ID_MODULO
                                                ).map((mod) => {
                                                    return (
                                                        <button
                                                            type="button"
                                                            className="btn"
                                                            key={mod.ID_MODULO}
                                                            onClick={() => {
                                                                props.setShow(
                                                                    true
                                                                );
                                                                props.setModal({
                                                                    headerComponent:
                                                                        mod.DS_MODULO,
                                                                    IconHeader:
                                                                        faAngleRight,
                                                                    Component:
                                                                        () => (
                                                                            <AbrirAtendimento
                                                                                ID_MODULO={
                                                                                    mod.ID_MODULO
                                                                                }
                                                                                setShow={
                                                                                    props.setShow
                                                                                }
                                                                                defaultDesc="Atendimento aberto pela tela de Gestão de Clientes do CRMv2"
                                                                                cliente={{
                                                                                    ...props.row,
                                                                                    PRODUTOS:
                                                                                        props.row.PRODUTOS.flatMap(
                                                                                            (
                                                                                                p
                                                                                            ) =>
                                                                                                p.UNIDADES.map(
                                                                                                    (
                                                                                                        u
                                                                                                    ) => ({
                                                                                                        DS_EMPREENDIMENTO:
                                                                                                            p.DS_PRODUTO,
                                                                                                        ID_EMPREENDIMENTO:
                                                                                                            p.ID_PRODUTO,
                                                                                                        UNIDADE:
                                                                                                            u,
                                                                                                    })
                                                                                                )
                                                                                        ),
                                                                                    CONTATOS:
                                                                                        props.row.CONTATOS.map(
                                                                                            (
                                                                                                c
                                                                                            ) => ({
                                                                                                DS_NOME_CONTATO:
                                                                                                    c.DS_NOME,
                                                                                                ID_CONTATO:
                                                                                                    c.ID_CONTATO,
                                                                                            })
                                                                                        ),
                                                                                }}
                                                                            />
                                                                        ),
                                                                    size: "xl",
                                                                });
                                                            }}
                                                        >
                                                            {mod.DS_MODULO}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="mb-4">
                            {cliente?.DS_PERFIL_FINANCEIRO_CONTA ? (
                                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                                    <span className="mr-4">
                                        <FontAwesomeIcon
                                            icon={faGem}
                                            className="icon-2x font-weight-bold text-primary"
                                        />
                                    </span>
                                    <div className="d-flex flex-column text-dark-75">
                                        <span className="font-size-sm">
                                            Perfil Financeiro
                                        </span>
                                        <span className="font-weight-bolder">
                                            {
                                                cliente?.DS_PERFIL_FINANCEIRO_CONTA
                                            }
                                        </span>
                                    </div>
                                </div>
                            ) : null}
                            {cliente.perfilTipoConta?.DS_PERFIL_TIPO_CONTA ? (
                                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                                    <span className="mr-4">
                                        <i
                                            style={{
                                                color: cliente.perfilTipoConta
                                                    ?.HX_COR_PERFIL_TIPO_CONTA,
                                            }}
                                            className={`${cliente.perfilTipoConta?.DS_ICON_PERFIL_TIPO_CONTA} icon-2x font-weight-bold`}
                                        />
                                    </span>
                                    <div className="d-flex flex-column text-dark-75">
                                        <span className="font-size-sm">
                                            Tipo Conta
                                        </span>
                                        <span className="font-weight-bolder">
                                            {
                                                cliente.perfilTipoConta
                                                    ?.DS_PERFIL_TIPO_CONTA
                                            }
                                        </span>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="d-flex flex-column justify-content-start">
                            <div className="d-flex align-items-center flex-wrap">
                                {/*alterar*/}
                                {cliente.PRODUTOS.map((produto) => {
                                    return produto.UNIDADES.map((unidade) => {
                                        return (
                                            <span
                                                key={
                                                    produto.DS_PRODUTO +
                                                    unidade.DS_UNIDADE
                                                }
                                                className="label label-light-info label-inline mr-2 my-1"
                                                style={{
                                                    height: "auto",
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faHome}
                                                    className="mr-1"
                                                />{" "}
                                                {produto.DS_PRODUTO} -{" "}
                                                {unidade.DS_UNIDADE}
                                            </span>
                                        );
                                    });
                                })}
                            </div>
                        </div>
                        <div className="d-flex flex-column justify-content-start">
                            <div className="d-flex align-items-center flex-wrap">
                                <span
                                    className="label label-light-info label-inline mr-2 my-1"
                                    style={{
                                        height: "auto",
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faMoneyCheck}
                                        className="mr-1"
                                    />{" "}
                                    {
                                        cliente?.CLASSIFICACAO_FINANCEIRA?.DS_CLASSIFICACAO
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="separator separator-solid my-3"></div>
                <div className="d-flex align-items-center justify-content-between flex-wrap ">
                    <div className="d-flex align-items-center  justify-content-between flex-wrap mw-25">
                        <div className="d-flex align-items-start align-items-sm-end my-1">
                            <span className="mr-4">
                                <i className="flaticon-network icon-2x text-muted font-weight-bold"></i>
                            </span>
                            <div
                                className="symbol-list d-flex flex-wrap y-scroll"
                                style={{ maxHeight: "80px" }}
                            >
                                {cliente.CONTATOS.map((contato) => {
                                    return (
                                        <div
                                            key={contato.ID_CONTATO}
                                            className="symbol symbol-circle symbol-30"
                                        >
                                            <button className="btn btn-sm btn-outline-dark btn-shadow  font-weight-bold mr-2 my-2">
                                                {contato.ID_CONTATO} -{" "}
                                                {contato.DS_NOME}
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
